import React from 'react';
import { motion } from 'framer-motion';
interface SlideLayoutProps {
  children: ReactNode;
  slideNumber: number;
  totalSlides: number;
  title?: string;
  subtitle?: string;
}
export function SlideLayout({
  children,
  slideNumber,
  totalSlides,
  title,
  subtitle
}: SlideLayoutProps) {
  return <div className="relative w-full h-screen overflow-hidden bg-white text-gray-900 selection:bg-purple-100 selection:text-purple-900" data-id="element-1">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-2">
        <div className="absolute top-[-20%] right-[-10%] w-[800px] h-[800px] bg-purple-100/40 rounded-full blur-[120px]" data-id="element-3" />
        <div className="absolute bottom-[-20%] left-[-10%] w-[600px] h-[600px] bg-indigo-100/30 rounded-full blur-[100px]" data-id="element-4" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-[radial-gradient(circle_at_center,rgba(168,85,247,0.05),transparent_70%)]" data-id="element-5" />
      </div>

      {/* Content Container */}
      <div className="relative z-10 w-full h-full max-w-7xl mx-auto px-8 py-12 flex flex-col" data-id="element-6">
        {/* Header */}
        {(title || subtitle) && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mb-8 border-b border-gray-200 pb-6" data-id="element-7">
            {title && <h2 className="text-4xl md:text-5xl font-bold text-gray-900 tracking-tight" data-id="element-8">
                {title}
              </h2>}
            {subtitle && <p className="text-xl text-purple-600 mt-2 font-light tracking-wide" data-id="element-9">
                {subtitle}
              </p>}
          </motion.div>}

        {/* Main Content Area */}
        <div className="flex-1 relative" data-id="element-10">{children}</div>

        {/* Footer / Slide Number */}
        <div className="absolute bottom-8 right-8 text-gray-300 font-mono text-sm" data-id="element-11">
          {slideNumber.toString().padStart(2, '0')} / {totalSlides}
        </div>
      </div>
    </div>;
}